import React, { useMemo } from 'react';
import { type App } from 'generated/graphql';

import Image from 'components/Image/Image';

import styles from './AppsList.module.scss';

interface Props {
  apps: App[];
  disableShrinkOnMobile?: boolean;
  isLoading?: boolean;
  getUrl?: (app: App) => string;
  showLabel?: boolean;
}

export const AppsList: React.FC<Props> = ({ apps, disableShrinkOnMobile, isLoading, getUrl, showLabel }) => {
  const appsWithUberFirst = useMemo(() => {
    return [...apps].sort((a, b) => {
      if (a.name.includes('Uber')) {
        return -1;
      }

      if (b.name.includes('Uber')) {
        return 1;
      }

      return 0;
    });
  }, [apps]);

  return (
    <ul
      className={`${styles.AppsList} ${disableShrinkOnMobile ? styles.DisableShrinkOnMobile : ''}`}
      data-testid="tile-app-list"
    >
      {appsWithUberFirst.map((app: App) => {
        const { id: appId, name, image } = app;

        const src = image || '/Images/NoApp.png';

        const inner = (
          <>
            <Image fallbackUrl="/Images/NoApp.png" isLoading={isLoading} src={src} alt={`Icon for ${name}`} />
            {showLabel && <span>{name}</span>}
          </>
        );

        return (
          <li key={appId} data-testid="tile-app-list-icon">
            {getUrl ? <a href={getUrl(app)}>{inner}</a> : inner}
          </li>
        );
      })}
    </ul>
  );
};
